export function appendGRecaptchaScript() {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('id', 'recaptcha-script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/enterprise.js?onload=recaptchaLoadCallback&render=explicit');
    recaptchaScript.setAttribute('async', '');
    recaptchaScript.setAttribute('defer', '');
    document.body.appendChild(recaptchaScript);
}

export function getGRecaptchaToken() {
    const gRecaptchaTokenInput = document.getElementById('app-grecaptcha-token')
    const gRecaptchaToken = gRecaptchaTokenInput?.getAttribute('value') ?? null;
    if (document.getElementById('app-grecaptcha-token') !== null) {
        document.getElementById('root').removeChild(gRecaptchaTokenInput);
    }

    return gRecaptchaToken;
}

export function removeGRecaptchaScript() {
    const recaptchaScript = document.getElementById('recaptcha-script');
    if (!recaptchaScript) return;
    document.body.removeChild(recaptchaScript);
}
